export default {
  ERROR: 'testEditorError'
};
